$(function () {
  $(".js-news-slider").slick({
    infinite: !0,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: !1,
    centerMode: !0,
    autoplay: !0,
    draggable: !0,
    dots: !1,
    responsive: [
      {
        breakpoint: 767,
        settings: { slidesToShow: 3, slidesToScroll: 1, arrows: !1, dots: !1 },
      },
      {
        breakpoint: 580,
        settings: { slidesToShow: 2, slidesToScroll: 1, arrows: !1, dots: !1 },
      },
    ],
  }),
    $(".news-slider__slider-nav .js-button-prev").click(function () {
      $(".js-news-slider").slick("slickPrev");
    }),
    $(".news-slider__slider-nav .js-button-next").click(function () {
      $(".js-news-slider").slick("slickNext");
    }),
    $(".js-product-slider").slick({
      infinite: !1,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: !1,
      autoplay: !1,
      draggable: !1,
      fade: !0,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: !1,
            dots: !0,
          },
        },
      ],
    }),
    $(".js-product-slider-nav").on("beforeChange", function () {
      var i = $(".slick-current").attr("data-slick-index");
      console.log(i);
    });
  var i = $(".product-slider-navigation__item").length;
  $(".product-slider-navigation__item").click(function () {
    $(".product-slider-navigation__item").removeClass("active"),
      $(this).addClass("active");
    var e = $(".product-slider-navigation__item.active").attr(
      "data-slick-index"
    );
    $(".js-product-slider").slick("slickGoTo", e - 1);
    var s = $(".product-slider-navigation__list").height(),
      t = $(".product-slider-navigation__list").width(),
      o = (s / i) * (e - 2),
      n = (t / i) * (e - 2);
    $(window).width() < 1023
      ? $(".product-slider-navigation").animate({ scrollLeft: n }, 300)
      : $(".product-slider-navigation").animate({ scrollTop: o }, 500);
  }),
    $(".product-slider__image")
      .on("mouseover", function () {
        $(this)
          .children(".product-slider__image_scale")
          .css({ transform: "scale(" + $(this).attr("data-scale") + ")" });
      })
      .on("mouseout", function () {
        $(this)
          .children(".product-slider__image_scale")
          .css({ transform: "scale(1)" });
      })
      .on("mousemove", function (i) {
        $(this)
          .children(".product-slider__image_scale")
          .css({
            "transform-origin":
              ((i.pageX - $(this).offset().left) / $(this).width()) * 100 +
              "% " +
              ((i.pageY - $(this).offset().top) / $(this).height()) * 100 +
              "%",
          });
      })
      .each(function () {
        $(this)
          .append('<div class="product-slider__image_scale"></div>')
          .children(".product-slider__image_scale")
          .css({
            "background-image": "url(" + $(this).attr("data-image") + ")",
          });
      }),
    $(".js-quantity-minus").click(function () {
      var i = $(this).parent().find("input"),
        e = parseInt(i.val()) - 1;
      return (e = e < 1 ? 1 : e), i.val(e), i.change(), !1;
    }),
    $(".js-quantity-plus").click(function () {
      var i = $(this).parent().find("input");
      return i.val(parseInt(i.val()) + 1), i.change(), !1;
    });
  var e = $(".skio-group-container--selected .skio-group-topline").html();
  $(".subscription__title_active").html(e),
    $(".js-subscription-title").click(function () {
      $(this).toggleClass("active"),
        $(".subscription__body").toggleClass("visible");
    }),
    $(".skio-group-container").click(function () {
      var i = $(this).find(".skio-group-topline").html();
      $(".subscription__title_active").html(i);
    }),
    $(".js-tabs-button").click(function () {
      $(".tabs__item").removeClass("active"),
        $(this).parent().addClass("active");
      let i = $(this).attr("href");
      return $(".tabs__content .tabs__pane").hide(), $(i).show(), !1;
    }),
    $(".js-subscribe-modal").click(function () {
      $(".subscribe-modal").removeClass("hidden"),
        $(".subscribe-modal").addClass("visible"),
        $("body").addClass("overflow-hidden");
    }),
    $(".js-close-modal,.js-modal-background").click(function () {
      $(this).closest(".modal").addClass("hidden"),
        setTimeout(function () {
          $(".modal").removeClass("visible"),
            $("body").removeClass("overflow-hidden");
        }, 500);
    }),
    $(function () {
      var i = new Swiper(".gallery-thumbs", {
          centeredSlides: !0,
          centeredSlidesBounds: !0,
          direction: "horizontal",
          spaceBetween: 10,
          slidesPerView: 5,
          freeMode: !1,
          watchSlidesVisibility: !0,
          watchSlidesProgress: !0,
          watchOverflow: !0,
          breakpoints: { 480: { direction: "vertical", slidesPerView: 5 } },
        }),
        e = new Swiper(".gallery-top", {
          direction: "horizontal",
          spaceBetween: 10,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          a11y: {
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
          },
          keyboard: { enabled: !0 },
          thumbs: { swiper: i },
        });
      e.on("slideChangeTransitionStart", function () {
        i.slideTo(e.activeIndex);
      }),
        i.on("transitionStart", function () {
          e.slideTo(i.activeIndex);
        });
    });
});
